/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2022] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { CollectionView } from 'backbone.marionette';

import ErrorView from '@/views/ErrorView';

import PRTNRDeviceAdminItemView from '../PRTNRDeviceAdminItemView';
import OrderDeviceAdminItemView from '../OrderDeviceAdminItemView';
import VB0DeviceAdminItemView from '../VB0DeviceAdminItemView';
import DefaultDeviceAdminItemView from '../DefaultDeviceAdminItemView';

const OrderDeviceAdminCollectionView = CollectionView.extend({
  className: 'order-device-admin-collection-view',

  childView(item) {
    switch (item.get('formTypeId')) {
      case '13':
      case '14':
      case '15':
        return PRTNRDeviceAdminItemView;
      case '17':
        return OrderDeviceAdminItemView;
      case '16':
      case '18':
      case '20':
      case '21':
        return VB0DeviceAdminItemView;
      case '22':
      case '23':
      case '24':
      case '25':
      case '26':
        return DefaultDeviceAdminItemView;
      default:
        return ErrorView;
    }
  }
});

export default OrderDeviceAdminCollectionView;
